"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarTrailingSection = void 0;
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
function NavBarTrailingSection({ className, children, ...rest }) {
    const defaultClasses = 'flex flex-row gap-[1rem] justify-end items-center';
    const merged = (0, clsx_1.default)(defaultClasses, className);
    return (react_1.default.createElement("div", { className: merged, ...rest }, children));
}
exports.NavBarTrailingSection = NavBarTrailingSection;
